module.exports = __webpack_public_path__ + "static/media/p1_7.be29cf0c.png";